<main>
  <ct-message-box-container role="alert">
    <mat-icon>error_outline</mat-icon>

    <ct-message-content>
      <h3>{{ 'OLD_UI_WARNING.TITLE' | translate }}</h3>

      <ct-message [innerHTML]="'OLD_UI_WARNING.MESSAGE' | translate" />

      <ct-message-actions>
        <button
          (click)="goToOldUi()"
          id="secondary-button"
          class="rs-btn--text"
          data-testid="old-ui-warning-continue-button"
          mat-button
        >
          {{ 'OLD_UI_WARNING.CONTINUE' | translate }}
        </button>

        <button
          (click)="cancel()"
          id="primary-button"
          data-testid="old-ui-warning-back-button"
          mat-button
        >
          {{ 'GO_BACK' | translate }}
        </button>
      </ct-message-actions>
    </ct-message-content>
  </ct-message-box-container>
</main>